import { useEffect } from "react";

// back up: not use anymore
export const JpPayRedirectPaymentPage = () => {
  async function on_pay() {
    const a = JSON.parse(
      sessionStorage.getItem("tamice/RedirectPayment/data") as string,
    );

    const extraData = {
      paymentUI: {
        language: "EN",
        logoUrl: "https://tamice.com/assets/icons/logo.png",
        colorTheme: "blue1",
      },
      payment: {
        paymethod: ["CARD", "CVS", "PAYpay", "LINEpay"],
        card: {
          payType: ["one", "installments"],
          installMonth: [3, 5, 6, 10, 12],
        },
        cvs: {
          notiUrl: a.notiUrl,
          contactInfo: "MerchantInfo",
          contactTelNum: "37-1234-1235",
          contactHours: "09:00-18:00",
          customerKana: "09:00-18:00",
          customerFirstKana: "09:00-18:00",
          paymentTermDay: 5,
        },
        linepay: {
          productImageUrl: "https://tamice.com/assets/icons/logo.png",
        },
      },
      sbpsPayment: {
        userId: "inicistest",
      },
    };
    console.log(a);
    console.log(extraData);
    if (true || window.confirm("check log")) {
      const myform = document.getElementById("payform") as HTMLFormElement;
      myform.method = "post";
      myform.action = "https://devcbt.inicis.com/cbtauth";
      myform.target = "_self";
      Object.keys(a).forEach((key) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = a[key];
        myform.appendChild(input);
      });
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "extraData";
      input.value = JSON.stringify(extraData);
      myform.appendChild(input);

      // detect child window close, using postMessage
      // window.addEventListener("message", (event) => {
      //   if (true) {
      //     // event.origin === "https://devcbt.inicis.com"
      //     const data = event.data;
      //     if (!data) return;
      //     console.log("data", data);
      //     if (data.startWiths("paymentSuccess/")) {
      //       const [, mid, sid] = data.split("/");
      //       alert("child window close: " + mid + "/" + sid);
      //     } else if (data === "paymentFail") {
      //       const [, mid, sid, resultCode] = data.split("/");
      //       alert("child window close: " + resultCode);
      //     }
      //   }
      // });

      // detect child window close
      const timer = setInterval(() => {
        console.log(myform.contentWindow);
        if (myform && myform.contentWindow && myform.contentWindow.closed) {
          clearInterval(timer);
          console.log(myform.contentWindow.document.body.innerHTML);
          alert("child window close");
        }
      }, 1000);

      myform.submit();
    }
  }
  useEffect(() => {
    on_pay();
  }, []);
  return (
    <div>
      <style>
        {`body {
        display: none
      }`}
      </style>
      <form name="payform" id="payform" method="post">
        {/* <button type="button" onClick={() => on_pay()}>
          Test payment
        </button> */}
      </form>
    </div>
  );
};
